import {getNewOutlet} from 'reconnect.js';
/* $$__CODEGEN_EXTRA_APPOUTLET_HEAD__$$ */

getNewOutlet('extra', {}, {autoDelete: false});
/* $$__CODEGEN_EXTRA_APPOUTLET_TAIL__$$ */
